export default {
  jp: {
    title: {
      member: 'アカウントをお持ちの方',
      new: 'はじめての方'
    },
    label: {
      id: 'ID',
      password: 'パスワード'
    },
    ph: {
      id: '登録メールアドレスを入力してください',
      password: 'パスワードを入力してください'
    },
    error: {
      id: {
        required: 'IDを入力してください。'
      },
      password: {
        required: 'パスワードを入力してください。',
        invalid: 'ID、またはパスワードの入力内容に誤りがあります。'
      }
    },
    button: {
      login: 'ログイン',
      entry: 'アカウント申請'
    },
    desc: {
      reminder1: 'パスワードを忘れた場合は',
      reminder2: 'こちら',
      reminder3: 'より再発行してください。',
      entry1: 'メディアポータルの利用には、以下よりアカウントの作成が必要です。',
      entry2: '※報道関係者専用サイトとなりますので、一般の方の登録はご遠慮ください。'
    }
  },
  en: {
    title: {
      member: 'Sign In',
      new: 'Sign Up'
    },
    label: {
      id: 'ID',
      password: 'Password'
    },
    ph: {
      id: 'Enter your email address',
      password: 'Enter your password'
    },
    error: {
      id: {
        required: 'Please enter your ID.'
      },
      password: {
        required: 'Please enter your password.',
        invalid: 'Your ID or password is incorrect.'
      }
    },
    button: {
      login: 'Login',
      entry: 'Apply for an Account'
    },
    desc: {
      reminder1: 'Please click ',
      reminder2: 'here',
      reminder3: ' to reset password.',
      entry1: 'You will need to creat an account below to use the MEDIA PORTAL.',
      entry2: '* This website is only for media.'
    }
  }

}
